import { ReactNode } from "react"
import { SubTitle, Text } from "../../Typography"
import { Separator } from "../../Separator"
import { Card } from "../../Card"
import * as styles from "./CardStyles"
import { Box } from "../../Box"
import { LegendItem } from "./Legend/LegendItem"
import { Data } from "../types"
import { Flex } from "../../Flex"

export type ChartCardProps = {
  title: string
  subtitle: string
}

type Props<TData, TLabel> = ChartCardProps & {
  children: ReactNode
  data?: Data<TData, TLabel>[]
  total?: number
  dataTestId?: string
}

export const ChartCard = <TData = unknown, TLabel = unknown>({
  title,
  subtitle,
  children,
  data,
  dataTestId,
}: Props<TData, TLabel>) => (
  <Card data-testid={dataTestId} css={styles.cardOuterContainer}>
    <Box css={styles.cardContainer}>
      <Box css={styles.marginBottom}>
        <SubTitle css={styles.title}> {title}</SubTitle>
        <Separator size="block" color="yellow" />
      </Box>
      <Text css={styles.subtitle}>{subtitle}</Text>
      <Flex css={styles.chartAndLegendWrap}>
        <Box css={styles.chartContainer}>{children}</Box>
        {data && (
          <Flex css={styles.legendContainer}>
            {data.map((item, index) => (
              <LegendItem<TData, TLabel> key={index} {...item} />
            ))}
          </Flex>
        )}
      </Flex>
    </Box>
  </Card>
)

ChartCard.defaultProps = {
  data: undefined,
  total: undefined,
  dataTestId: undefined,
}
